export const emptyContact = {
    contactid: "",
    fullname: "",
    shipping_method: "",
    preferred_contact_method: "",
    address_type: "",
    account_name: "",
    account_tt_statementname: "",
    account_tt_grades: "",
    account_tt_enrollment: null,
    account_address1_line2: "",
    account_address1_line1: "",
    account_address1_stateorprovince: "",
    account_address1_county: "",
    account_address1_city: "",
    account_tt_taxexemptinfo: "",
    account_accountid: "",
    parentCustomerId: "",
    account_address1_postalcode: "",
    account_telephone1: "",
    account_AccountNumber: "",
    account_tt_stateprovinceid: "",
    account_tt_programschedulecomplete: false,
    account_tt_GPUpdateFlag: false,
    account_tt_salesrepid: "",
    account_tt_salescoordinatorid: "",
    firstName: "",
    lastName: "",
    address1_line1: "",
    address1_line2: "",
    telephone1: "",
    mobilephone: "",
    telephoneNumber: "",
    address1_city: "",
    emailaddress1: "",
    email: "",
    tt_stateprovinceid: "",
    address1_postalcode: ""
};

export const shippingMethodOptions = [
    "UPS",
    "FedEx",
    "USPS",
    "Courier",
    "Customer Pickup"
];

export const getContactId = (contactItem) => {
    if (!contactItem) {
        return null;
    }
    return contactItem.contactid;
};

export const buildTelephoneValue = (telephoneNumber) => {
    return telephoneNumber ? telephoneNumber.toString().trim() : "";
};

export const phoneRegex = /^(?:\(?[2-9]\d{2}\)?[\s.-]?[2-9]\d{2}[\s.-]?\d{4})$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeCompareValue = (value) => {
    return value ? value.toString().trim().toLowerCase() : "";
};

export const mapContactResponse = (response) => {
    return (response || []).map((item) => {
        const telephone = item.telephone1 || "";

        return {
            ...emptyContact,
            ...item,
            contactid: item.contactid || "",
            fullname: item.fullname || "",
            firstName: item.firstName || "",
            lastName: item.lastName || "",
            telephone1: telephone,
            mobilephone: item.mobilephone || "",
            telephoneNumber: telephone,
            emailaddress1: item.emailaddress1 || "",
            email: item.emailaddress1 || "",
            preferred_contact_method: item.preferred_contact_method || "",
            shipping_method: item.shipping_method || "",
            address_type: item.address_type || "",
            account_name: item.account_name || "",
            account_accountid: item.account_accountid || "",
            parentCustomerId: item.parentCustomerId || "",
            address1_line1: item.address1_line1 || "",
            address1_line2: item.address1_line2 || "",
            address1_county: item.address1_county || "",
            address1_city: item.address1_city || "",
            tt_stateprovinceid: item.tt_stateprovinceid || "",
            address1_postalcode: item.address1_postalcode || ""
        };
    });
};

export const buildContactInputModel = ({ contact, editingContactItem, parentCustomerId }) => {
    const firstName = contact.firstName ? contact.firstName.trim() : "";
    const lastName = contact.lastName ? contact.lastName.trim() : "";
    const email = contact.emailaddress1 ? contact.emailaddress1.trim() : "";
    const telephone = buildTelephoneValue(contact.telephoneNumber || contact.telephone1 || contact.mobilephone);
    const contactRecordId = getContactId(contact)
        || getContactId(editingContactItem)
        || "00000000-0000-0000-0000-000000000000";

    const resolvedParentCustomerId = parentCustomerId
        || contact.parentCustomerId
        || contact.account_accountid
        || contact.accountid
        || "00000000-0000-0000-0000-000000000000";

    return {
        contactid: contactRecordId && contactRecordId !== "00000000-0000-0000-0000-000000000000" ? [contactRecordId] : [],
        columnnames: [
            "parentCustomerId",
            "firstName",
            "lastName",
            "address1_line1",
            "address1_line2",
            "address1_county",
            "telephone1",
            "address1_city",
            "emailaddress1",
            "tt_stateprovinceid",
            "address1_postalcode",
            "preferred_contact_method",
            "shipping_method",
            "address_type"
        ],
        recordId: contactRecordId,
        parentCustomerId: resolvedParentCustomerId,
        firstName: firstName,
        lastName: lastName,
        address1_line1: contact.address1_line1 || "",
        address1_line2: contact.address1_line2 || "",
        address1_county: contact.address1_county || "",
        telephone1: telephone,
        address1_city: contact.address1_city || "",
        emailaddress1: email,
        tt_stateprovinceid: contact.tt_stateprovinceid || "",
        address1_postalcode: contact.address1_postalcode || "",
        preferred_contact_method: contact.preferred_contact_method || "",
        shipping_method: contact.shipping_method || "",
        address_type: contact.address_type || ""
    };
};

export const mergeContactsByContactId = (...contactLists) => {
    const addedContactKeys = {};
    const mergedContacts = [];

    contactLists.flat().forEach((contactItem) => {
        if (!contactItem) {
            return;
        }

        const contactKey = normalizeCompareValue(contactItem.contactid);

        if (contactKey && addedContactKeys[contactKey]) {
            return;
        }

        if (contactKey) {
            addedContactKeys[contactKey] = true;
        }

        mergedContacts.push(contactItem);
    });

    return mergedContacts;
};
